export default {

}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/select-dates/resources/index.js